import { useEffect } from 'react';

import { mustRefreshAuthenticationSelector } from '@redux/authentication';
import { sessionEndTimestampSelector } from '@redux/session/selectors';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';

export const useTriggerSignOut = () => {
  const sessionEndTimestamp = useSelector(sessionEndTimestampSelector);
  const mustRefreshAuthentication = useSelector(mustRefreshAuthenticationSelector);

  useEffect(() => {
    if (mustRefreshAuthentication && !sessionEndTimestamp) {
      Auth.signOut();
    }
  }, [mustRefreshAuthentication, sessionEndTimestamp]);
};
